<template>
<StoreModal
    class="business-wallet__archive-modal"
    :name="`WidgetDeleteConfirmation`"
    @closeModal="closeModal"
>
  <template #header>
    <div class="create-business-modal__header">
      <div class="icon">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_26470_402396)">
            <rect width="60" height="60" rx="10" fill="#CF5252"/>
            <path d="M24.8098 18.2197C24.9504 18.079 25.1412 18 25.3401 18H34.6599C34.8588 18 35.0496 18.079 35.1902 18.2197L41.7803 24.8098C41.921 24.9504 42 25.1412 42 25.3401V34.6599C42 34.8588 41.921 35.0496 41.7803 35.1902L35.1902 41.7803C35.0496 41.921 34.8588 42 34.6599 42H25.3401C25.1412 42 24.9504 41.921 24.8098 41.7803L18.2197 35.1902C18.079 35.0496 18 34.8588 18 34.6599V25.3401C18 25.1412 18.079 24.9504 18.2197 24.8098L24.8098 18.2197ZM25.6508 19.5L19.5 25.6508V34.3492L25.6508 40.5H34.3492L40.5 34.3492V25.6508L34.3492 19.5H25.6508Z" fill="white"/>
            <path d="M28.5023 34.5C28.5023 33.6716 29.1739 33 30.0023 33C30.8307 33 31.5023 33.6716 31.5023 34.5C31.5023 35.3284 30.8307 36 30.0023 36C29.1739 36 28.5023 35.3284 28.5023 34.5Z" fill="white"/>
            <path d="M28.6493 25.4926C28.5693 24.6934 29.1969 24 30 24C30.8031 24 31.4307 24.6934 31.3507 25.4926L30.8246 30.7537C30.7823 31.1774 30.4258 31.5 30 31.5C29.5742 31.5 29.2177 31.1774 29.1754 30.7537L28.6493 25.4926Z" fill="white"/>
          </g>
          <defs>
            <clipPath id="clip0_26470_402396">
              <rect width="60" height="60" fill="white"/>
            </clipPath>
          </defs>
        </svg>

      </div>
    </div>
  </template>
  <template  #body>
    <new-spinner v-if="isLoading" class="body-info-spinner" />
    <div v-else class="body-info">
      <div class="title">{{ $t('widgets.warning') }}</div>
      <div class="desc" v-html="$t('widgets.warningDeleteDesc')" />
    </div>
  </template>


  <template #footer>
    <div class="footer">
      <base-button
          class="close-btn"
          type="secondary"
          :label="$t('business-wallet.modals.archive-toggle-modal.buttons.close')"
          @click="closeModal"
      />
      <base-button
          class="archive-btn"
          type="primary"
          :disable="isLoading"
          :label="$t('widgets.delete')"
          @click="!isLoading ? handleDelete() : null"
      />
    </div>
  </template>
</StoreModal>
</template>

<script>
  import {mapActions, mapMutations, mapState} from "vuex";
  import {
    getTruncatedString
  } from "@/entries/checkout/filters";
  import {deleteWidget} from "@/public/store/modules/widgetsManage/actions/deleteWidget";

  export default {
    name: 'WidgetDeleteConfirmation',
    components: {
      StoreModal: () => import(/* webpackChunkName: "/public/components/modals/StoreModal" */ '/public/components/modals/StoreModal'),
      BaseButton: () => import(/* webpackChunkName: "public/components/common/uiKit/button/base/bg-secondary" */ '/public/components/common/uiKit/button/base/bg-secondary'),
      NewSpinner: () => import (/* webpackChunkName: "/public/components/common/uiKit/spinner" */ "/public/components/common/uiKit/spinner/index.vue")
    },
    props: {
      value: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      ...mapState('app', {
        modalPayload: state => state.modal.payload,
      }),
      ...mapState('widgetsManage', ['isLoading']),
    },
    methods: {
      ...mapActions('app', [
        'closeModal',
      ]),
      ...mapActions('widgetsManage', ['deleteWidget', 'fetchWidgets']),
      ...mapMutations('widgetsManage', ['setLoading']),
      async handleDelete () {
        this.setLoading(true)
        await this.deleteWidget(this.modalPayload.id)
        await this.fetchWidgets()
        await this.closeModal()
        this.setLoading(false)
      }
    },
  };

</script>

<style lang="scss" scoped>
.business-wallet {
  &__archive-modal {
    font-family: $Gilroy;
    font-weight: 500;

    &::v-deep .main-modal-header {
      padding-bottom: 0!important;
      max-height: 180px;
    }

    .icon {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 30px;
    }
    .title {
      color: var(--text-text-primary, #FFF);
      text-align: center;
      font-size: 32px;
      font-weight: 500;
      line-height: 40px; /* 125% */
      letter-spacing: 0.38px;
      margin-bottom: 20px;
    }
    .desc {
      color: var(--text-color-text-secondary, #7E7E7E);
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      &-accent {
        color: var(--text-text-primary, #FFF);
      }
    }

    .body-info {
      padding: 0 30px 30px;
    }
    .body-info-spinner {
      display: flex;
      align-items: center;
      justify-content: center;

      width: 100%;
      height: 150px;
    }
    .footer {
      display: flex;
      align-items: center;
      justify-content: space-between;

      flex-wrap: nowrap;
      gap: 20px;

      padding: 0 15px;

      .archive-btn, .close-btn {
        width: 100%;
      }

      @include below_tablet() {
        flex-wrap: wrap;
        gap: 10px;

        .archive-btn, .close-btn {
          width: 100%;
          max-width: 100%;
        }
      }
    }
  }
}
</style>
